define('shared/util/dispatchers/publishers/form',['$', 'shared/lib/RSVP'],
function($, RSVP){
    'use strict';

    function createFieldIfFieldIsNotEmpty(name, value) {
        var me = this;
        var $form = me.$form;
        var $targets = me.$form.find('input[name="' + name + '"]');
        var $target, $t;

        for(var l = $targets.length; l--;) {
            $t = $targets.eq(l);
            if ($t.val() === value) {
                return;
            }
            if ($t.val() === '') {
                $target = $t;
                break;
            }
        }

        if (!$target) {
            $target = $('<input />')
            .attr({
                type: 'hidden',
                name: name,
                value: ''
            })
            .appendTo($form);
        }

        $target.val(value);
    }

    function getFields($form, key) {
        return $form.find('input[name="'+ key +'"], select[name="' + key + '"]');
    }

    return function (key, value, options) {
        var me = this;
        return new RSVP.Promise(function(resolve){
            var $cur;
            var $el = getFields(me.$form, key);
            var type = $el.attr('type');
            var pluralKey = options.pluralKey || key;

            if (options.ignoreNull == true && value == null) {
                resolve();
                return;
            }

            if (Array.isArray(value)) {
                if ($el.length < 0) {
                    return;
                }

                $el.remove();
                getFields(me.$form, pluralKey).remove();

                for(var i = 0; i < value.length; i++) {
                    if (options.ignoreNull == true && value == null) {
                        continue;
                    }
                    createFieldIfFieldIsNotEmpty.call(me, pluralKey, value[i]);
                }
            }
            else {
                if (options.autoCreation && $el.length <= 0) {
                    $el = $('<input>')
                    .attr({
                        type: 'hidden',
                        name: key,
                        value: value
                    })
                    .appendTo(me.$form);
                }
                if (type != 'radio') {
                    $el.val(value);
                }
                else {
                    for(var l = $el.length; l--;) {
                        $cur = $el.eq(l);
                        if ($cur.attr('name') === value) {
                            $cur.prop('checked', true);
                        }
                        else {
                            $cur.prop('checked', false);
                        }
                    }
                }
            }
            resolve();
        });
    };
});

